<div class="not-found-container">
          <div class="error-code">404</div>
          <div class="error-message">Oops! Page not found</div>
          <p class="error-description">
                    The page you're looking for doesn't exist or has been moved.
          </p>
          <a routerLink="/" class="home-link">Go Back Home</a>
</div>